import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { DefaultButton, IconButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Col, Row, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { __MessageTypes, __NotificationClass, enum__NOTIFICATION_CLASS, enum__NOTIFICATION_INBOX_TYPE, enum__NOTIFICATION_TYPE, ENUM_NOTIFICACION_CLASE_BANDEJA } from '../../../../common/Dictionaries';
import { isNullUndefined, isNullUndefinedOrEmpty, showMessage } from '../../../../common/Helpers';
import MessageBoxInfoComplex from '../../../../components/Common/Message/MessageBoxInfoComplex';
import { action_updateAlertCounter, action_updateAlertList, action_updateFirstLoadList, action_updateIsPanelNotificationOpen, action_updateNotificationSearchIdentifiers } from '../../../../reducers/actions/SITE/actions';
import { useGetNotificationPanelListByClass } from '../../../../hooks/services/NotificationTask/useOfNotificacionTask';
import { Icon } from '@fluentui/react';
import { __onGoToNotificationPage } from '../../../../common/SystemRedirections';
import { setNotificationViewed } from '../../../../services/sNotificationAlerts/notificationAlerts.service';
import moment from 'moment';
import AchieveValidateNotificationDialog from '../../../../pages/sNotificationTasks/SidePanels/AchieveValidate/AchieveValidateNotificationDialog';
import SidePanelAchieveValidateNotification from '../../../../pages/sNotificationTasks/SidePanels/AchieveValidate/SidePanelAchieveValidateNotification';

const SidePanelAlerts = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const inputParam_NotificationType = !isNullUndefinedOrEmpty(props.inputParam_NotificationType) ? props.inputParam_NotificationType : ENUM_NOTIFICACION_CLASE_BANDEJA.CONTRACTUAL;

    const {
        _firsLoadList: firsLoadList,
        _isPanelNotificationAlertOpen: isPanelNotificationAlertOpen,
        _alertList: alertList,
        _alerDialogTitle: alerDialogTitle,
        _alertCounter: alertCounter,
        _alertSearchIdentifiers: alertSearchIdentifiers,
    } = useSelector((state) => state.notificationAlertState);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [notificationTaskSelected, setNotificationTaskSelected] = useState(null);
    const [isPanelAchieveValidateNotificationOpen, setIsPanelAchieveValidateNotificationOpen] = useState(false);

    useGetNotificationPanelListByClass(alertSearchIdentifiers.rootId, alertSearchIdentifiers.itemId, inputParam_NotificationType, alertList, firsLoadList, isPanelNotificationAlertOpen)

    const onDismissPanel = () => {
        showMessage(setMessageConfig, false, null, null)
        dispatch(action_updateNotificationSearchIdentifiers(null, null));
        dispatch(action_updateAlertList(null))
        dispatch(action_updateFirstLoadList(false))
        dispatch(action_updateIsPanelNotificationOpen(false))
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBoxInfoComplex
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                            inputParam_ShowClose={true}
                        />
                    </Col>
                    <Col xl={12}>
                        <PrimaryButton className='mx-1' onClick={ () => __onGoToNotificationPage() }>{ t('data-lang-btn-gotonotificationpage') }</PrimaryButton>
                        <DefaultButton className='mx-1' onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    const getPriorityColor = (priority) => {
		switch (priority) {
			case 1: return "red"   ; break;
			case 2: return "orange"; break;
			case 3: return "yellow"; break;
			case 4: return "green" ; break;
			default: return "blue" ; break;
		}
	}

    const onNotificationTaskSelected = async (notificationTask) => {
        await setNotificationViewed(notificationTask.id, true).then(async (response) => {
            if (response.data.succeeded) {
                if (notificationTask.viewed === false) {
                    dispatch(action_updateAlertCounter(alertCounter -1));
                }
                setNotificationTaskSelected(notificationTask);
                setIsPanelAchieveValidateNotificationOpen(true);
            }
            else {
                //showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
            }
        }).catch(() => {
            //showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
        });
	}

    const getPriorityData = (value) => {
        const prioridadReal = value % 10; 
        
        const tipoIcono = Math.floor(value / 100);

        return {
            originalPriority: prioridadReal,
            auxiliarPriority: tipoIcono || null
        };
    };

    const subjetCellsRenderer = (objItem) => {
        const normalizedNotificationClass = __NotificationClass.find(x => x.key === objItem.notificationClassId);
        const aux_priority = getPriorityData(objItem.priority);
        
        return  <Row style={{marginLeft: "0px", borderLeft: `5px solid ${getPriorityColor(aux_priority.originalPriority)}`}} className='cursor-pointer'>
                    <Col className="col-auto ms-auto my-auto p-0">
                        <IconButton
                            iconProps={{ iconName: 'EntryView' }}
                            title={objItem.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE ? t('data-lang-btn-detailedachiement') : (objItem.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_VALIDATE ? t('data-lang-btn-detailedvalidation') : t('data-lang-btn-view')) }
                            ariaLabel={objItem.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE ? t('data-lang-btn-detailedachiement') : (objItem.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_VALIDATE ? t('data-lang-btn-detailedvalidation') : t('data-lang-btn-view')) }
                            onClick={() => onNotificationTaskSelected(objItem)}
                        />
                    </Col>
                    <Col className="col-auto ms-auto my-auto">
                    {
                        (objItem.notificationTypeId === enum__NOTIFICATION_TYPE.ANNOUNCEMENT || objItem.notificationTypeId === enum__NOTIFICATION_TYPE.ANNOUNCEMENT_ROLE) &&
                        <Icon iconName="Ringer" title={t('data-lang-lbl-announcement')} />
                    }
                    {
                        (objItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK || objItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK_ROLE) &&
                        <Icon iconName="Flag" title={t('data-lang-lbl-task')} />
                    }
                    </Col>
                    <Col className='cursor-pointer my-auto'>
                        <Row>
                            { objItem.title }
                        </Row>
                        <Row>
                            <Col className='col-auto ms-auto border rounded bg-green cursor-pointer my-auto mx-1' style={{fontSize: "10px"}}> { !isNullUndefined(normalizedNotificationClass) ? t(normalizedNotificationClass.text) : objItem.notificationClass } </Col>
                            <Col className='col-auto ms-auto border rounded bg-green cursor-pointer my-auto mx-1' style={{color: "white", fontSize: "10px", backgroundColor: `${objItem.completed ? "green" : "#b71f1f"}`}}> { objItem.completed ? t('data-lang-lbl-completed') : t('data-lang-lbl-notcompleted') } </Col>
                            <Col></Col>
                        </Row>
                    </Col>
                    <Col className="col-auto me-auto d-flex my-auto">
                        {
                            objItem.important === true &&
                            <Row className="d-flex align-items-center rounded-pill overflow-hidden mx-2" style={{ width: "fit-content" }}>
                                <Col className="d-flex align-items-center justify-content-center" style={{ fontWeight: "bolder", width: 32, height: 26 }}>
                                    <Icon style={{fontSize: "21px", color: "red"}} className="cursor-pointer my-1 mx-1 px-1" iconName={'AlertSolid'}  text={t('data-lang-lbl-important')} title={t('data-lang-lbl-important')} aria-label={t('data-lang-lbl-important')} />
                                </Col>
                            </Row>
                        }
                        {
                            !isNullUndefined(aux_priority.auxiliarPriority) &&
                            <Row className="d-flex align-items-center rounded-pill overflow-hidden mx-2" style={{ width: "fit-content" }}>
                                <Col className="d-flex align-items-center justify-content-center" style={{ fontWeight: "bolder", width: 32, height: 26 }}>
                                    <Icon style={{fontSize: "21px"}} className="cursor-pointer my-1 mx-1 px-1" iconName={'ReportWarning'} text={t('data-lang-lbl-preventadnapproval-long2')}   title={t('data-lang-lbl-preventadnapproval-long2')}   aria-label={t('data-lang-lbl-preventadnapproval-long2')} />
                                </Col>
                            </Row>
                        }
                        {
                            (objItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK || objItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK_ROLE) && (moment(objItem.expirationDate).toDate() < moment(objItem.completedDate).toDate()) &&
                            <Row className="d-flex align-items-center rounded-pill overflow-hidden mx-2" style={{ width: "fit-content" }}>
                                <Col className="d-flex align-items-center justify-content-center" style={{ fontWeight: "bolder", width: 32, height: 26 }}>
                                    <Icon style={{fontSize: "21px"}} className="cursor-pointer my-1 mx-1 px-1" iconName={'RemoveEvent'} text={t('data-lang-lbl-expired')}   title={t('data-lang-lbl-expired')}   aria-label={t('data-lang-lbl-expired')} />
                                </Col>
                            </Row>
                        }
                        {
                            (objItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK || objItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK_ROLE) && objItem.completed &&
                            <Row className="d-flex align-items-center rounded-pill overflow-hidden mx-2" style={{ width: "fit-content" }}>
                                    
                                    <Col className="bg-primary text-white d-flex align-items-center justify-content-center" style={{ fontWeight: "bolder", width: 32, height: 26 }}>
                                        <Icon
                                            iconName="CheckMark"
                                            text={t('data-lang-lbl-completed')}
                                            title={t('data-lang-lbl-completed')}
                                            aria-label={t('data-lang-lbl-completed')} 
                                        />
                                    </Col>
                            </Row>
                        }
                    </Col>
                </Row>
    };

    return (
        <div>
            <Panel
                isOpen={ isPanelNotificationAlertOpen }
                isBlocking={true}
                onDismiss={ onDismissPanel }
                headerText={ t(alerDialogTitle) }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row>
                    <Col xs={12}>
                        {
                            firsLoadList && alertList &&
                            <Table className="border">
                                <thead  className="border">
                                    <th className="border" style={{width: "100%"}}>{t('data-lang-lbl-subject')}</th>
                                </thead>
                                <tbody  className="table-body border">
                                    {
                                        alertList.length > 0 && alertList.map(notificationTask => (
                                            <tr key={notificationTask.id}>
                                                <td className="m-0 p-0 py-1">
                                                    { subjetCellsRenderer(notificationTask) }
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    {
                                        alertList.length === 0 && 
                                        <tr>
                                            <td className="m-0 p-0 py-1">
                                                {t('data-lang-msg-alertsempty')}
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </Table>
                        }
                    </Col>
                </Row>
                {
                    !isNullUndefined(notificationTaskSelected) && isPanelAchieveValidateNotificationOpen &&
                    <SidePanelAchieveValidateNotification
                        inputParam_NotificationTask={notificationTaskSelected}
                        inputParam_IsPanelOpen={isPanelAchieveValidateNotificationOpen}
                        inputParam_SetterIsPanelOpen={setIsPanelAchieveValidateNotificationOpen}
                        inputParam_NeedUpdateNotificationPageList={false}
                    />
                }
            </Panel>
        </div>
    );
};

SidePanelAlerts.propTypes = {
};

export default SidePanelAlerts;